import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import AuthRouter from './routers/AuthRouter'
import { AuthProvider } from './components/auth/useAuth'
import AdminPrivateRouter from './routers/AdminPrivateRouter'
import AdminRouter from './routers/AdminRouter'
import DepartmentPrivateRouter from './routers/DepartmentPrivateRouter'
import DepartmentRouter from './routers/DepartmentRouter'
import CommercialPrivateRouter from './routers/CommercialPrivateRouter'
import CommercialRouter from './routers/CommercialRouter'

export default function App() {
	return (
		<>
			<BrowserRouter>
				<AuthProvider>
					<Routes>
						<Route path="/admin/*" element={ <AdminPrivateRouter><AdminRouter /></AdminPrivateRouter>} />
						<Route path="/department/*" element={ <DepartmentPrivateRouter><DepartmentRouter /></DepartmentPrivateRouter>} />
						<Route path="/commercial/*" element={ <CommercialPrivateRouter><CommercialRouter /></CommercialPrivateRouter>} />
						<Route path="*" element={<AuthRouter />}/>
					</Routes>
				</AuthProvider>
			</BrowserRouter>
		</>
	)
}